export default "__VITE_ASSET__c1ea073b__"